import PGModel from '../../../models/secure/PGModel';

const getPGClientKey = async (context) => {
    let pgModel = new PGModel();
    return pgModel.getClientPGKey().then(res => {
        let commitTarget = (res.data && res.data.status == PGModel.STATUS_SUCCESS) ? 'SET_CLIENT_KEY' : 'CLEAR_CLIENT_KEY';
        context.commit(commitTarget, res.data.records);
        return res.data.records;
    }).catch(err => pgModel.getErrorResponse(err));
}

// Payload required: { items: [ {id: value}, {...} ] }
const createPGIntent = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.createPaymentIntent(payload).then(res => {
        let commitTarget = (res.data && res.data.status == PGModel.STATUS_SUCCESS) ? 'SET_INTENT_KEY' : 'CLEAR_INTENT_KEY';
        context.commit(commitTarget, res.data.records.intentKey);
        return res.data.records.intentKey;
    }).catch(err => pgModel.getErrorResponse(err));
}

const beforeCreateSubscriptionChecks = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.beforeCreateSubscriptionChecks(payload)
        .then(res => {
            if (res.data && res.data.status === PGModel.STATUS_SUCCESS) {
                return res.data;
            } else {
                context.commit('CLEAR_SUBSCRIPTION');
            }
            return res.data;
        })
        .catch(err => pgModel.getErrorResponse(err));
};

const createSubscription = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.createSubscription(payload)
        .then(res => {
            let commitTarget = (res.data && res.data.status === PGModel.STATUS_SUCCESS)
                ? 'SET_SUBSCRIPTION'
                : 'CLEAR_SUBSCRIPTION';

            context.commit(commitTarget, res.data.records || {});
            return res.data;
        })
        .catch(err => pgModel.getErrorResponse(err));
};

const postCreateSubscriptionChecks = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.postCreateSubscriptionChecks(payload)
        .then(res => {
            let commitTarget = (res.data && res.data.status === PGModel.STATUS_SUCCESS && res.data.records)
                ? 'SET_SUBSCRIPTION'
                : 'CLEAR_SUBSCRIPTION';

            context.commit(commitTarget, res.data.records || {});
            return res.data;
        })
        .catch(err => pgModel.getErrorResponse(err));
};

const cancelSubscription = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.cancelSubscription(payload)
        .then(res => {
            let commitTarget = (res.data && res.data.status === PGModel.STATUS_SUCCESS)
                ? 'CLEAR_SUBSCRIPTION'
                : 'SET_SUBSCRIPTION';

            context.commit(commitTarget, res.data.records || {});
            return res.data;
        })
        .catch(err => pgModel.getErrorResponse(err));
};

const getSubscriptionInfo = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.getSubscriptionInfo(payload).then(res => {
        let commitTarget = (res.data && res.data.status == PGModel.STATUS_SUCCESS) ? 'SET_SUBSCRIPTION_INFO' : 'CLEAR_SUBSCRIPTION_INFO';
        context.commit(commitTarget, res.data.records);
        return res.data;
    }).catch(err => pgModel.getErrorResponse(err));
}

const getReceiptSource = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.getReceiptSource(payload).then(res => {
        let commitTarget = (res.data && res.data.status == PGModel.STATUS_SUCCESS) ? 'SET_RECEIPT_SOURCE' : 'CLEAR_RECEIPT_SOURCE';
        context.commit(commitTarget, res.data.records);
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const updatePaymentMethod = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.updatePaymentMethod(payload).then(res => {
        let commitTarget = (res.data && res.data.status == PGModel.STATUS_SUCCESS) ? 'SET_UPDATE_CC_RESULT' : 'CLEAR_UPDATE_CC_RESULT';
        context.commit(commitTarget, res.data);
        return res.data;
    }).catch(err => pgModel.getErrorResponse(err));
}

const finalizeUpdatePaymentMethod = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.finalizeUpdatePaymentMethod(payload).then(res => {
        let commitTarget = (res.data && res.data.status == PGModel.STATUS_SUCCESS) ? 'SET_UPDATE_CC_RESULT' : 'CLEAR_UPDATE_CC_RESULT';
        context.commit(commitTarget, res.data);
        return res.data;
    }).catch(err => pgModel.getErrorResponse(err));
}

const updateSubscriptionStatus = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.updateSubscriptionStatus(payload).then(res => {
        let commitTarget = (res.data && res.data.status == PGModel.STATUS_SUCCESS) ? 'SET_UPDATE_SUBSCRIPTION' : 'CLEAR_UPDATE_SUBSCRIPTION';
        context.commit(commitTarget, res.data.records);
        return res.data;
    }).catch(err => pgModel.getErrorResponse(err));
}

const autoSyncSubscription = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.autoSyncSubscription(payload).then(res => {
        let commitTarget = (res.data && res.data.status == PGModel.STATUS_SUCCESS) ? 'SET_AUTO_SYNC_SUBSCRIPTION' : 'CLEAR_AUTO_SYNC_SUBSCRIPTION';
        context.commit(commitTarget, res.data);
        return res.data;
    }).catch(err => pgModel.getErrorResponse(err));
}

const pendingSubscriptionSync = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.pendingSubscriptionSync(payload).then(res => {
        let commitTarget = (res.data && res.data.status == PGModel.STATUS_SUCCESS) ? 'SET_PENDING_AUTO_SYNC' : 'CLEAR_PENDING_AUTO_SYNC';
        context.commit(commitTarget, res.data);
        return res.data;
    }).catch(err => pgModel.getErrorResponse(err));
}

const clearPendingSubscriptionSync = (context) => {
    context.commit('CLEAR_PENDING_AUTO_SYNC');
}

const setItemCharge = (context, payload) => {
    context.commit('SET_ITEM_CHARGE', payload);
};

const clearItemCharge = (context) => {
    context.commit('CLEAR_ITEM_CHARGE');
};

const setSuccessFlag = (context, payload) => {
    context.commit('SET_SUCCESS_FLAG', payload);
};

const clearSuccessFlag = (context) => {
    context.commit('CLEAR_SUCCESS_FLAG');
};

const setFreeMonth = (context, payload) => {
    context.commit('SET_FREE_MONTH', payload);
};

const clearFreeMonth = (context) => {
    context.commit('CLEAR_FREE_MONTH');
};

const setUpdateCC = (context, payload) => {
    context.commit('SET_UPDATE_CC', payload);
};

const clearUpdateCC = (context) => {
    context.commit('CLEAR_UPDATE_CC');
};

const clearUpdateCCResult = (context) => {
    context.commit('CLEAR_UPDATE_CC_RESULT');
};

const setReadAgreement = (context, payload) => {
    context.commit('SET_READ_AGREEMENT', payload);
};

const clearReadAgreement = (context) => {
    context.commit('CLEAR_READ_AGREEMENT');
};

const clearSubscriptionInfo = (context) => {
    context.commit('CLEAR_SUBSCRIPTION_INFO');
};

const clearStates = (context) => {
    context.commit('CLEAR_STATES');
};

const createSetupIntent = async (context, payload) => {
    let pgModel = new PGModel();
    return pgModel.createSetupIntent(payload).then(res => {
            let commitTarget = (res.data && res.data.status === PGModel.STATUS_SUCCESS)
                ? 'SET_SETUP_INTENT'
                : 'CLEAR_SETUP_INTENT';

            context.commit(commitTarget, res.data.records || {});
            return res.data;
        }).catch(err => pgModel.getErrorResponse(err));
};

export {
    createPGIntent,
    getPGClientKey,
    beforeCreateSubscriptionChecks,
    createSubscription,
    postCreateSubscriptionChecks,
    cancelSubscription,
    updatePaymentMethod,
    finalizeUpdatePaymentMethod,
    autoSyncSubscription,
    pendingSubscriptionSync,
    clearPendingSubscriptionSync,
    updateSubscriptionStatus,
    setItemCharge,
    clearItemCharge,
    getSubscriptionInfo,
    clearSubscriptionInfo,
    getReceiptSource,
    setSuccessFlag,
    clearSuccessFlag,
    setFreeMonth,
    clearFreeMonth,
    setUpdateCC,
    clearUpdateCC,
    clearUpdateCCResult,
    setReadAgreement,
    clearReadAgreement,
    clearStates,
    createSetupIntent,
}
